import { render, staticRenderFns } from "./PolicyBordItemList.vue?vue&type=template&id=47003726&"
import script from "./PolicyBordItemList.vue?vue&type=script&lang=js&"
export * from "./PolicyBordItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports